import { render } from "./CriarUsuarios.vue?vue&type=template&id=ae4aa8d6"
import script from "./CriarUsuarios.vue?vue&type=script&lang=js"
export * from "./CriarUsuarios.vue?vue&type=script&lang=js"
script.render = render

export default script